import { useState } from 'react';

interface Props {
  action: string;
  description: string;
  target: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export function WriteConfirmation({ action, description, target, onConfirm, onCancel }: Props) {
  const [confirmed, setConfirmed] = useState(false);

  return (
    <div className="write-confirm-card">
      <div className="write-confirm-header">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M8 1l1.5 3 3.5.5-2.5 2.5.5 3.5L8 9l-3 1.5.5-3.5L3 4.5 6.5 4z" stroke="currentColor" strokeWidth="1.2" fill="none"/>
        </svg>
        <span className="write-confirm-action">Write Action: {action}</span>
      </div>
      <p className="write-confirm-desc">{description}</p>
      <div className="write-confirm-target">
        <span className="write-confirm-target-label">Target:</span>
        <code>{target}</code>
      </div>
      {!confirmed ? (
        <div className="write-confirm-actions">
          <button className="btn-recommended btn-sm" onClick={() => { setConfirmed(true); onConfirm(); }}>
            Confirm
          </button>
          <button className="btn-secondary btn-sm" onClick={onCancel}>
            Cancel
          </button>
        </div>
      ) : (
        <div className="write-confirm-done">Action confirmed</div>
      )}
    </div>
  );
}
